//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.BaseRadialDimensionBuilder.js";
import "../Annotations/Annotations.DrivingValueBuilder.js";
import "../no/Dimensions.js";
import "../no/ugmath.js";
let d=[[[1,"Driving",0,"Annotations.DrivingValueBuilder",0],[0,"ForeshorteningSymbol",0,"Annotations.ForeshorteningSymbolBuilder",0],[0,"IsAutoplaced",1,0]],[[["nth","secondaryOrigin"],"SetNthSecondaryOrigin",{},2,0],[["nth"],"GetNthSecondaryOrigin",{R_:{secondaryOrigin:''}},1,0],[["nth","secondaryArrowheadOrientation"],"SetNthSecondaryArrowheadOrientation",{},2,0],[["nth"],"GetNthSecondaryArrowheadOrientation",{R_:{secondaryArrowheadOrientation:''}},1,0],[["numOfSecondaryCallouts"],"GetSecondaryCallouts",{R_:{secondaryCallouts:"Annotations.Dimension[]"}},0,0]],[]];
SPLM.Annotations.RadialDimensionBuilder = class extends SPLM.Annotations.BaseRadialDimensionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.RadialDimensionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;